/* global axios */

import ApiClient from './ApiClient';

const client = new ApiClient('facebook_imports', { accountScoped: true });
const syncClient = new ApiClient('facebook_sync_settings', {
  accountScoped: true,
});

export const facebookImportsAPI = {
  list(inboxId) {
    return axios.get(client.url, {
      params: inboxId ? { inbox_id: inboxId } : {},
    });
  },

  get(id) {
    return axios.get(`${client.url}/${id}`);
  },

  create(data) {
    return axios.post(client.url, data);
  },

  pause(id) {
    return axios.post(`${client.url}/${id}/pause`);
  },

  resume(id) {
    return axios.post(`${client.url}/${id}/resume`);
  },

  cancel(id) {
    return axios.post(`${client.url}/${id}/cancel`);
  },

  estimate(inboxId) {
    return axios.get(`${client.url}/estimate`, {
      params: { inbox_id: inboxId },
    });
  },
};

export const facebookSyncSettingsAPI = {
  get(inboxId) {
    return axios.get(`${syncClient.url}/${inboxId}`);
  },

  save(inboxId, data) {
    return axios.post(`${syncClient.url}/${inboxId}`, {
      facebook_sync_settings: data,
    });
  },

  syncNow(inboxId) {
    return axios.post(`${syncClient.url}/${inboxId}/sync_now`);
  },
};
